import { GlobalExclusionsAppWebComponent } from './component/GlobalExclusionsAppWebComponent';
import { WEB_COMPONENT_GLOBAL_EXCLUSIONS_APP } from '../../webcomponents.constants';

/**
 * The component for Exclusions tab from Configuration Profiles page
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { GlobalExclusionsAppWebComponent };

window.customElements.define(WEB_COMPONENT_GLOBAL_EXCLUSIONS_APP, GlobalExclusionsAppWebComponent);
